<template>
  <div class="map-container">
    <div id="map"></div>
  </div>
</template>
<script>
import L from "leaflet";

export default {
  props: {
    data: {},
  },
  data() {
    return {
      map: {},
    };
  },
  mounted() {
    this.map = L.map("map").setView([this.data.lat, this.data.lng], 9);

    // Add Tile Provider
    this.addTileProvider();

    // Add Tile Provider
    this.addMarker();
  },
  methods: {
    //Add Tile Provider
    addTileProvider() {
      L.tileLayer("http://www.google.com/maps/vt?lyrs=m&x={x}&y={y}&z={z}", {
        title: "نقشه شهری گوگل",
        id: "GoogleStreets",
        className: "map-tiles",
        link: "http://www.google.com/maps/vt?lyrs=m&x={x}&y={y}&z={z}",
        attribution: "Google",
        maxNativeZoom: 19,
        maxZoom: 21,
      }).addTo(this.map);
    },

    addMarker() {
      L.marker([this.data.lat, this.data.lng])
        .addTo(this.map)
        .bindPopup(
          ` راننده : ${this.data.name} <br /> وضعیت : ${this.data.action} <br /> تاریخ : ${this.data.created_at}`
        )
        .openPopup();
    },
  },
};
</script>

<style lang="scss">
.map-container {
  max-height: 330px;
  height: 100%;

  #map {
    height: 100%;
  }
}

.leaflet-top {
  display: none;
}

.leaflet-popup-pane {
  right: 20px;
}
</style>
